import {
  ApiError,
  ApiErrorInitialState,
} from '@hellodarwin/core/lib/features/entities/api-entitites';
import { GoogleDriveFile } from '@hellodarwin/core/lib/features/entities/google-drive-entities';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../app/app-store';
import ClientApiV2 from '../client-api-v2';
import SliceRequest from '../slice-request';

export interface GoogleDriveState {
  status: 'idle' | 'pending';
  error: ApiError;
}

const initialState: GoogleDriveState = {
  status: 'idle',
  error: ApiErrorInitialState,
};

export const copyFileToProgramFolder = SliceRequest<
  GoogleDriveFile,
  {
    api: ClientApiV2;
    programId: string;
    fileId: string;
    cancelIfAlreadyExists?: boolean;
  }
>('googleDrive/copyFileToProgramFolder', async ({ api, programId, fileId, cancelIfAlreadyExists }) => {
  const response = await api.post<GoogleDriveFile>(
    `/google-drive/programs/${programId}/${fileId}/copy`,
    { cancelIfAlreadyExists },
  );
  return response.data;
});

const googleDriveSlice = createSlice({
  name: 'googleDrive',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(copyFileToProgramFolder.pending, (state) => {
      state.status = 'pending';
    });
    builder.addCase(copyFileToProgramFolder.fulfilled, (state) => {
      state.status = 'idle';
    });
    builder.addCase(copyFileToProgramFolder.rejected, (state, { payload }) => {
      state.error = payload ?? ApiErrorInitialState;
      state.status = 'idle';
    });
  },
});

export const googleDriveReducer = googleDriveSlice.reducer;

export const selectGoogleDriveStatus = (state: RootState) =>
  state.googleDrive.status;
